export const LEGALSTATUS_OTHER = 'Other'
